import { Outlet, useMatch } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { SettingsCustomizationsPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import CustomizationSettings from 'modules/settings/components/CustomizationSettings'

const CustomizationsPage = () => {
  const { navigation } = useNavigation()
  const { data } = useQuery(SettingsCustomizationsPageDocument)
  const isCustomizationRoute = useMatch(navigation.settings.customizations.fullPath())

  const canManageCustomization = !!data?.apiCore._policies.companyManageCustomization.can
  const canManageTables =
    hasFeature('employees_custom_tables') &&
    !!data?.employees._policies.manageCustomTableSettings.can

  return (
    <AuthorizeUser authorizeFn={() => canManageCustomization}>
      {isCustomizationRoute ? (
        <ResponsivePage.Body
          variant="narrow"
          header={{
            title: i18n.t('settings.customization.title'),
            backLink: { href: navigation.settings.fullPath(), label: '' },
          }}
        >
          <CustomizationSettings canManageTables={canManageTables} />
        </ResponsivePage.Body>
      ) : (
        <Outlet />
      )}
    </AuthorizeUser>
  )
}

export default CustomizationsPage
